import React, { useState } from "react";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../../store/user";
import axios from "axios";
import { toast } from "react-toastify";
import { useEffect } from "react";

export default function Outdoor() {
	let dispatch = useDispatch();
	const userName = useSelector((state) => state.User.userName);
	const userEmail = useSelector((state) => state.User.userEmail);
	const userPhone = useSelector((state) => state.User.userPhone);
	const userAddress = useSelector((state) => state.User.userAddress);
	const userCity = useSelector((state) => state.User.userCity);
	const userState = useSelector((state) => state.User.userState);
	const userCountry = useSelector((state) => state.User.userCountry);
	const country = useSelector((state) => state.User.country);
	const state = useSelector((state) => state.User.state);
	const city = useSelector((state) => state.User.city);
	const delivery = useSelector((state) => state.User.delivery);
	const userExist = useSelector((state) => state.User.userAddress);
	const userLocation = useSelector((state) => state.User.userLocation);
	const location = useSelector((state) => state.User.location);
	const token = useSelector((state) => state.Company.auth_token);
	const shippingEnabled = useSelector((state) => state.Company.shippingsEnabled);

	// console.log(shippingEnabled);

	useEffect(() => {
		const getCountry = async () => {
			try {
				const res = await axios.get(`https://demo.cranesoft-digitalmenu.com/api/v1/Country`, {
					headers: {
						Authorization: token,
					},
				});

				dispatch(UserActions.setCountry(res.data));
			} catch (error) {}
		};
		(shippingEnabled === '1') && getCountry();
	}, [dispatch, token, shippingEnabled]);
	useEffect(() => {
		const getState = async () => {
			try {
				const res = await axios.get(`https://demo.cranesoft-digitalmenu.com/api/v1/StateByCountry/${userCountry}`, {
					headers: {
						Authorization: token,
					},
				});

				dispatch(UserActions.setState(res.data));
			} catch (error) {}
		};
		(shippingEnabled === '1') && getState();
	}, [dispatch, token, shippingEnabled, userCountry]);

	useEffect(() => {
		const getCity = async () => {
			try {
				const res = await axios.get(`https://demo.cranesoft-digitalmenu.com/api/v1/CityByState/${userState}`, {
					headers: {
						Authorization: token,
					},
				});

				dispatch(UserActions.setCity(res.data));
			} catch (error) {}
		};
		getCity();
	}, [dispatch, token, userState]);
	useEffect(() => {
		const getLocation = async () => {
			try {
				const res = await axios.get(`https://demo.cranesoft-digitalmenu.com/api/v1/ShippingLocationByCityId/${userCity}`, {
					headers: {
						Authorization: token,
					},
				});
				dispatch(UserActions.setLocation(res.data));
			} catch (error) {}
		};
		(shippingEnabled === '1') && getLocation();
	}, [dispatch, token, shippingEnabled, userCity, userState]);

	const calculateDeliveryPrice = () => {
		const selectedLocation = location.find((loc) => loc.id === Number(userLocation));
		// console.log(selectedLocation);
		if (selectedLocation) {
			const newDeliveryPrice = selectedLocation.Rate;
			dispatch(UserActions.setDelivery(newDeliveryPrice));
		} else {
			// console.log("selected location not avaliable");
		}
	};


	const handleUserEmail = (e) => {
		dispatch(UserActions.setUserEmail(e.target.value))
		if(userEmail === ''){
			dispatch(UserActions.setUserName(''));
			dispatch(UserActions.setUserPhone(''));
			dispatch(UserActions.setUserAddress(''));
			dispatch(UserActions.setUserCity(''));
			dispatch(UserActions.setUserState(''));
			dispatch(UserActions.setUserCountry(''));
		}
	};

	
	//end code


	return (
		<div className="w-[100%] m-auto my-5">
			<label className="text-sm font-bold ">Full Name</label>
			<input
				value={userName}
				type="text"
				name="name"
				onChange={(e) => dispatch(UserActions.setUserName(e.target.value))}
				className={`${userExist === true ? "disable" : null} w-[100%] mt-2 mb-2 max-sm:mb-5 border border-dark/30 rounded-md py-2 px-3 outline-none`}
			/>

			<div className="grid grid-cols-2 gap-5">
				<div className="flex flex-col">
					<label className="text-sm font-bold ">Email Address</label>
					<input value={userEmail} type="emailaddress" name="email" onChange={handleUserEmail} className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none" />
				</div>

				<div className="flex flex-col">
					<label className="text-sm font-bold ">Phone Number</label>
					<input
						type="tel"
						name="phone"
						value={userPhone}
						autoComplete="on"
						onChange={(e) => dispatch(UserActions.setUserPhone(e.target.value))}
						className="w-[100%] mt-2 mb-2 max-sm:mb-5 border py-2 px-3 border-dark/30 rounded-md p-3 outline-none"
					/>
				</div>
			</div>
			<label className="text-sm font-bold">Address</label>

			<div className="flex items-center mt-3 py-1 mb-2 bg-white border border-dark/30 px-6 rounded-lg">
				<FontAwesomeIcon icon={faLocationDot} size="lg" className="text-dark/50" />
				<input value={userAddress} type="address" onChange={(e) => dispatch(UserActions.setUserAddress(e.target.value))} className="w-[100%] p-1 max-sm:mb-5 outline-none" />
			</div>

			{shippingEnabled === '1' && 
			<>
			<div className="grid grid-cols-2 gap-5">
				<div className="flex flex-col">
					<label className="text-sm font-bold ">Country</label>
					<select
						name="country"
						id=""
						value={userCountry}
						onChange={(e) => dispatch(UserActions.setUserCountry(e.target.value))}
						className=" mt-2 mb-2 max-sm:mb-5 py-2 px-3 border border-dark/30 rounded-md p-3 outline-none"
					>
						<option value="">Select country</option>
						{country.map((con, i) => (
							<option key={i} value={con.id}>
								{con.Name}
							</option>
						))}
					</select>
				</div>
				<div className="flex flex-col">
					<label className="text-sm font-bold ">State</label>
					<select
						name="state"
						id=""
						value={userState}
						onChange={(e) => dispatch(UserActions.setUserState(e.target.value))}
						className=" mt-2 mb-2 max-sm:mb-5 py-2 px-3 border border-dark/30 rounded-md p-3 outline-none"
					>
						<option value="">Select state</option>
						{state.map((con, i) => (
							<option key={i} value={con.id}>
								{con[0]}
							</option>
						))}
					</select>
				</div>
				<div className="flex flex-col">
					<label className="text-sm font-bold ">City</label>
					<select
						name="state"
						id=""
						value={userCity}
						onChange={(e) => dispatch(UserActions.setUserCity(e.target.value))}
						className=" mt-2 mb-2 max-sm:mb-5 py-2 px-3 border border-dark/30 rounded-md p-3 outline-none"
					>
						<option value="">Select city</option>
						{city.map((con, i) => (
							<option key={i} value={con.id}>
								{con[0]}
							</option>
						))}
					</select>
				</div>
				<div className="flex flex-col">
					<label className="text-sm font-bold ">Shipping Location</label>
					<select
						name="state"
						id=""
						value={userLocation}
						onChange={(e) => dispatch(UserActions.setUserLocation(e.target.value))}
						className=" mt-2 mb-2 max-sm:mb-5 py-2 px-3 border border-dark/30 rounded-md p-3 outline-none"
					>
						<option value="">Select Location</option>
						{location.map((con, i) => (
							<option key={i} value={con.id}>
								{con.Name}
							</option>
						))}
					</select>
				</div>
			</div>
			{userCity && calculateDeliveryPrice()}

			{userCity ? (
				<div className="flex justify-between mb-4">
					<p className="font-extrabold text-dark">Delivery Fee for: </p>
					<p className="font-extrabold text-xl">{delivery}</p>
				</div>
			) : (
				<div className="mt-5 text-danger text-center font-bold">
					<h1>Delivery not available in this location</h1>
				</div>
			)}
			</>
			}
		</div>
	);
}
